import QuantityProduct from './QuantityProduct'

class DronePremiumPhotoProduct extends QuantityProduct {
  static MINIMUM_QUANTITY = 5
}

export default DronePremiumPhotoProduct
